import { render, staticRenderFns } from "./PhoneInput.vue?vue&type=template&id=18a747ac&scoped=true"
import script from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PhoneInput.vue?vue&type=style&index=0&id=18a747ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a747ac",
  null
  
)

export default component.exports